"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _shared.StyledDialog;
  }
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _shared.StyledDialogContent;
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _shared.StyledDialogActions;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _shared.StyledTitleSection;
  }
});
exports["default"] = exports.Modal = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _default_theme = _interopRequireDefault(require("./default_theme"));
var _shared = require("./shared");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// @ts-expect-error - TS7016 - Could not find a declaration file for module './default_theme'. 'src/azalea/components/modals/default_theme.js' implicitly has an 'any' type.

var StyledModal = exports.Modal = function StyledModal(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(_styles.StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(_default_theme["default"], null, children));
};
StyledModal.Header = _shared.StyledTitleSection;
StyledModal.Container = _shared.StyledDialog;
StyledModal.Content = _shared.StyledDialogContent;
StyledModal.Footer = _shared.StyledDialogActions;
var _default = exports["default"] = StyledModal;